import * as tslib_1 from "tslib";
import { observer } from 'mobx-react';
import { getIncompleteGetStartedTasksNumber, getAllGetStartedTasksNumber, initializeGetStartedTasksLazy, } from 'owa-get-started';
import { GetStartedPane } from 'owa-header-pane';
import { getActiveCharm } from 'owa-header-store';
import strings from 'owa-strings/owa-getstarted-strings';
import * as React from 'react';
import HeaderCharm from './HeaderCharm';
import { logUsage } from 'owa-analytics';
import GetStartedCallout from './GetStartedCallout';
import { LightningId } from 'owa-lightning-v2';
import { toggleCharm } from 'owa-header-store';
import { getOwaWorkload } from 'owa-workloads';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
var GetStartedCharm = /** @class */ (function (_super) {
    tslib_1.__extends(GetStartedCharm, _super);
    function GetStartedCharm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onGetStartedClicked = function () {
            if (getActiveCharm() !== 7 /* GetStartedCharm */) {
                logUsage('getStartedCharmClicked', null, null, {
                    isCore: true,
                });
            }
            if (!isControlFeatureEnabled('fwk-o365shellheader')) {
                toggleCharm(7 /* GetStartedCharm */);
            }
        };
        return _this;
    }
    GetStartedCharm.prototype.componentDidMount = function () {
        initializeGetStartedTasksLazy.importAndExecute();
    };
    GetStartedCharm.prototype.render = function () {
        var allGetStartedTasksNumber = getAllGetStartedTasksNumber();
        if (allGetStartedTasksNumber > 1 && getOwaWorkload() == 1 /* Mail */) {
            return (React.createElement("div", null,
                React.createElement(HeaderCharm, { key: "getstarted", icons: {
                        iconName: "Lightbulb" /* Lightbulb */,
                    }, title: strings.getStarted_FlexPane_Title, ariaLabel: strings.getStarted_FlexPane_Title, behavior: {
                        paneComponent: isControlFeatureEnabled('fwk-o365shellheader')
                            ? null
                            : GetStartedPane,
                        charm: 7 /* GetStartedCharm */,
                        onClick: this.onGetStartedClicked,
                    }, getBadgeCount: getIncompleteGetStartedTasksNumber }),
                React.createElement(GetStartedCallout, { lid: LightningId.GetStartedFlexPane, when: function (lightup) { return lightup(); } })));
        }
        return null;
    };
    GetStartedCharm = tslib_1.__decorate([
        observer
    ], GetStartedCharm);
    return GetStartedCharm;
}(React.Component));
export default GetStartedCharm;
//# sourceMappingURL=GetStartedCharm.js.map